import { render } from "./InlineLoader.vue?vue&type=template&id=20d964ca&scoped=true"
import script from "./InlineLoader.vue?vue&type=script&lang=js"
export * from "./InlineLoader.vue?vue&type=script&lang=js"

import "./InlineLoader.vue?vue&type=style&index=0&id=20d964ca&scoped=true&lang=css"

import exportComponent from "/home/ad5hitotsuki/hitotsuki.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d964ca"]])

export default __exports__